/**
 * Renvoie vers la connexion quand la session cesse d'etre valide en cours de
 * navigation.
 *
 * Le middleware `auth.global` ne charge la session qu'une fois. Une session
 * revoquee depuis un autre poste (page « Appareils et sessions »), expiree ou
 * coupee par une deconnexion globale laissait donc l'interface affichee :
 * chaque appel d'API echouait en 401, et l'utilisateur voyait des listes
 * vides sans comprendre qu'il n'etait plus connecte.
 *
 * Seuls les 401 marques `session_expiree` par le serveur (`sessionPerdue()`)
 * declenchent la redirection. Les autres 401 sont des erreurs metier -- mot
 * de passe actuel incorrect, code faux -- et restent affiches a l'utilisateur.
 */
export default defineNuxtPlugin(() => {
  const router = useRouter()
  const store = useAuthStore()
  let redirectionEnCours = false

  globalThis.$fetch = $fetch.create({
    onResponseError({ response }) {
      if (response.status !== 401 || redirectionEnCours) return
      if ((response._data as { data?: { code?: string } } | undefined)?.data?.code !== 'session_expiree') return

      // Routeur et store sont pris a l'installation du plugin : le callback
      // s'execute apres un `await`, hors du contexte Nuxt
      const route = router.currentRoute.value
      if (route.path === '/login') return

      redirectionEnCours = true
      store.user = null
      store.impersonating = false
      store.impersonator = null
      Promise.resolve(router.push({ path: '/login', query: { redirect_after: route.fullPath } }))
        .finally(() => { redirectionEnCours = false })
    },
  }) as typeof globalThis.$fetch
})
